import React, { Component } from "react"
import MetaTags from "react-meta-tags"
import {
    Card,
    CardBody,
    Col,
    Container,
    FormGroup,
    Label,
    Row,
    InputGroup,
    Alert,
} from "reactstrap"

import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import { AvForm, AvField, AvGroup } from "availity-reactstrap-validation"

import PropsTypes from "prop-types"
import { connect } from "react-redux"

import { postGRPBirthDetails } from "store/group/reports/actions"
import { getPlacesAPIToken } from "store/actions"

import { getPlaces } from "helpers/backend_helper"
import { countries } from "common/data/country"

import PageLoader from 'pages/Common/PageLoader'
import { isEmpty, isEqual } from "lodash"
import AsyncSelect from "react-select/async"
import { ROUTER_GROUP } from "helpers/router_helper"
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert"
import { POST_GRP_BIRTH_DETAILS } from "store/group/reports/actionTypes"

import { RESULT_OK, RESULT_ERROR } from "store/baseActionTypes"
import universitylogo from "assets/images/dricon.png"
import { VIEW_GROUP_DOCTOR, VIEW_GROUP_UNIVERSITY } from "helpers/view_helper"
import { VIEW_GROUP_NGO } from "helpers/view_helper"

class BirthDetails extends Component {
    constructor(props) {
        super(props)

        this.state = {
            actionResultChanged: false,
            actionResult: {},
            selectedPlace: [],
            passPlaceErrorField: '',
            passPlaceErrorElement: false,
            dateOfBirth: '',
            date: new Date(),
            time: '00:00 AM',
            loading: false,
            country: {'name':'India','pcode':'+91','code':'IN'},
            countryCode: '+91',
            aadharNumber: '',
            passportNumber: '',
            birthDetail: {},
            birthCountry: 'IN',
            placesToken: '',
        }
        this.handleValidSubmit = this.handleValidSubmit.bind(this)
        this.handleViewReport = this.handleViewReport.bind(this)
    }

    handleCountry = (event) => {
        let country = JSON.parse(event.target.value);
        this.setState({
            country: country.name,
            countryCode: country.pcode
        })
    }

    componentDidMount() {
        const { placesAPIToken } = this.props
        placesAPIToken();
    }

    componentDidUpdate(prevProps, prevState) {
        const { birthDetail, actionResult, loading, placesToken } = this.props
        if (!isEmpty(actionResult) && !isEqual(prevProps.actionResult, actionResult)) {
            //console.log("componentDidUpdate->actionResult changed")
            this.setState({ actionResult, actionResultChanged: true })
        }

        if (!isEqual(prevProps.loading, loading)) {
            this.setState({ loading: loading })
        }

        // if (!isEmpty(birthDetail)) {
        //     console.log("componentDidUpdate->userBirthChartListPage not empty");
        //     if (!isEqual(prevProps.birthDetail, birthDetail)) {
        //         console.log("componentDidUpdate->birthChartListPageChanged");
        //         this.setState({ birthDetail: birthDetail })
        //     }
        // }

        if (!isEmpty(placesToken) && !isEqual(prevProps.placesToken, placesToken)) {
            //console.log("componentDidUpdate->placesToken")
           // console.log("placesToken, ", placesToken)
            this.setState({ placesToken })
        }
    }

    // handleValidSubmit
    handleValidSubmit(event, values) {
        console.log("handleValidSubmit->called")
        event.preventDefault();
        const { postbirthDetails } = this.props
        let birthDetail = values;
        birthDetail.tabValue = this.state.activeTab
        birthDetail.meridies = "Am"
        if (this.state.time === "00:00 AM") {
            birthDetail.timeOfBirth = "00:00:00 AM";
        } else {
            birthDetail.timeOfBirth = new Date(this.state.time).toTimeString();
        }
        birthDetail.dateOfBirth = new Date(this.state.date).toDateString();
        if (this.state.selectedPlace.length === 0) {
            this.setState({
                passPlaceErrorField: 'is-invalid',
                passPlaceErrorElement: true
            })
            return
        } else {
            birthDetail.country = this.state.selectedPlace.country
            birthDetail.countryCode = this.state.countryCode
            birthDetail.timeZone = 'UTC+05:30'
            birthDetail.placeId = this.state.selectedPlace.value
            birthDetail.placesToken = this.state.placesToken
            this.setState({
                passPlaceErrorField: '',
                passPlaceErrorElement: false
            })
        }
       // console.log("birthDetal, ", birthDetail)
        postbirthDetails(birthDetail, this.props.history)
    }

    loadSelectedPlace = async (placeInput, callback) => {
        //const response = await fetch(`http://localhost:8181/api/getPlaces/${inputText}`);
        if (placeInput.length < 4)
            return;
        const response = await getPlaces(this.state.birthCountry, placeInput, this.state.placesToken)
        console.log(response)
        const json = await response
        console.log(json)
        callback(json.map(o => ({
            label: o.description,
            value: o.place_id + '|' + o.description,
            state: '',
            country: '',
            latitude: '',
            longitude: '',
            timeZone: ''
        })))
    }

    handleGenerateReport() {
        console.log("handleGenerateReport->called")
        window.location.reload();
    }

    handleViewReport() {
        console.log("handleViewReport->called")
        this.props.history.push(ROUTER_GROUP + "/report-summary/" + this.state.birthDetail.birthInputId)
    }

    // renderResult = () => {
    //     let { actionResult, actionResultChanged } = this.state
    //     console.log("handleUpdateResult :::::::")
    //     console.log("actionResult :::::::", actionResult)
    //     console.log("actionResultChanged :::::::", actionResultChanged)
    //     if (actionResultChanged === true && !isEmpty(actionResult)) {
    //         console.log("renderActionResultDlg->actionResultChanged")
    //         switch (actionResult.action) {
    //             case POST_GRP_BIRTH_DETAILS:
    //                 if (actionResult.result === RESULT_OK) {
    //                     return <SweetAlert
    //                         success
    //                         title={
    //                             <span>
    //                                 Report generated successfull,<br></br>
    //                                 <small>Click Ok to view report, Cancel to generate New Report</small>
    //                             </span>
    //                         }
    //                         custom
    //                         customIcon={logolight}
    //                         showCancel
    //                         confirmButtonText="Click to View Report"
    //                         confirmBtnBsStyle="success"
    //                         cancelBtnBsStyle="danger"
    //                         onConfirm={() => {
    //                             console.log("confirm button triggered")
    //                             this.setState({ actionResultChanged: false })
    //                             this.handleViewReport()
    //                         }}
    //                         onCancel={() => {
    //                             console.log("cancel button triggered")
    //                             this.setState({ actionResultChanged: false })
    //                             this.handleGenerateReport()
    //                         }}
    //                     >
    //                     </SweetAlert>
    //                 } else if (actionResult.result === RESULT_ERROR) {
    //                     return <SweetAlert
    //                         error
    //                         title="Report generate failed"
    //                         onConfirm={() => {
    //                             console.log("cancel button triggered")
    //                             this.setState({ actionResultChanged: false })
    //                             this.handleGenerateReport()
    //                         }}
    //                     >
    //                     </SweetAlert>
    //                 }
    //                 return null
    //         }
    //     }
    //     return null
    // }

    renderLoader = () => {
        console.log("loading :::", this.state.loading)
        if (this.state.loading === true)
            return <PageLoader loaderMsg="Generating report... please wait..." />
        return null
    }

    render() {
        let groupType = "none"
        let branchName = "";
        let groupName = "";

        if (sessionStorage.getItem("groupType")) {
          groupType = JSON.parse(sessionStorage.getItem("groupType"));
          groupType = JSON.parse(sessionStorage.getItem("groupType")).groupType;
        }
        if (sessionStorage.getItem("branchName")) {
            branchName = JSON.parse(sessionStorage.getItem("branchName"));
            branchName = JSON.parse(sessionStorage.getItem("branchName")).branchName;
          }
          if (sessionStorage.getItem("groupName")) {
            groupName = JSON.parse(sessionStorage.getItem("groupName"));
            groupName = JSON.parse(sessionStorage.getItem("groupName")).groupName;
          }


        return (
            <React.Fragment>
                <MetaTags>
                    <title>
                        Generate AI Report | Kattam - AI Report
                    </title>
                </MetaTags>
                <div className="page-content">
                    {/* {this.renderLoader()} */}
                    {/* {this.renderResult()} */}
                    <Container fluid={true}>
                        <Breadcrumbs title="" breadcrumbItem="Generate AI Report" />
                        <Card>
                            <CardBody >

                                <AvForm className="form-horizontal"
                                    onValidSubmit={this.handleValidSubmit}
                                >
                                    <Row>
                                   
                                    <Col lg="8">
                                    {isEqual(groupType, VIEW_GROUP_UNIVERSITY) &&
                      ( <h5 className="font-size-18 me-3 bg-gradient .avatar-lg" color="#556ee6"><img src={universitylogo} alt="" height="30px"/> {groupName} , ({branchName}) </h5>)}
                                   
                                    </Col>
                                    </Row>
                                    <Alert color="info" className="mb-4" role="alert">
                                        <h5 className="font-size-16 me-3">Birth details</h5>
                                    </Alert>
                                    <Row>
                                        <Col lg="6">
                                            <AvGroup className="mb-3">
                                                <Label>
                                                    First name <span style={{ color: 'red' }}>*</span>
                                                </Label>
                                                <AvField
                                                    name="firstName"
                                                    placeholder="First name"
                                                    type="text"
                                                    errorMessage="Please enter a first name"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </AvGroup>
                                        </Col>
                                        <Col lg="6">
                                            <AvGroup className="mb-3">
                                                <Label>
                                                    Last name
                                                </Label>
                                                <AvField
                                                    name="lastName"
                                                    className="form-control"
                                                    placeholder="Last name"
                                                    type="text"
                                                    validate={{
                                                        pattern: { value: '^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9 ]*)?$', errorMessage: 'Last name can only contain aphanumeric and space' },
                                                        maxLength: { value: 30, errorMessage: 'Last name must not be greater than 30 characters.' }
                                                    }}
                                                />
                                            </AvGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="4">
                                            <AvGroup className="mb-3 select2-container">
                                                <Label>
                                                    Gender <span style={{ color: 'red' }}>*</span>
                                                </Label>
                                                <AvField type="select"
                                                    name="gender"
                                                    //helpMessage="Idk, this is an example. Deal with it!"
                                                    required
                                                    errorMessage="Please select a gender"
                                                >
                                                    <option disabled value="">Select gender</option>
                                                    <option>Male</option>
                                                    <option>Female</option>
                                                    <option>Others</option>
                                                </AvField>
                                            </AvGroup>
                                        </Col>
                                        <Col lg="4">
                                            <div className="form-group mb-4">
                                                <Label>
                                                    Birth Date <span style={{ color: 'red' }}>*</span>
                                                </Label>
                                                <div className="input-group">
                                                    <Flatpickr
                                                        className="form-control d-block"
                                                        placeholder="dd M,yyyy"
                                                        options={{
                                                            altInput: true,
                                                            altFormat: "F j, Y",
                                                            dateFormat: "Y-m-d",
                                                            defaultDate: "today"
                                                        }}
                                                        onChange={date => {
                                                            this.setState({ date });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg="4">
                                            <FormGroup className="mb-3">
                                                <Label>
                                                    Birth Time <span style={{ color: 'red' }}>*</span>
                                                </Label>

                                                <InputGroup>
                                                    <Flatpickr
                                                        className="form-control d-block"
                                                        placeholder="HH:MM AM"
                                                        options={{
                                                            enableTime: true,
                                                            noCalendar: true,
                                                            dateFormat: "H:i",
                                                            defaultDate: "00:00 AM",
                                                            time_24hr: false,
                                                            minuteIncrement: 1,
                                                        }}
                                                        onChange={time => {
                                                            this.setState({ time });
                                                        }}
                                                    />
                                                    <div className="input-group-append">
                                                        <span className="input-group-text">
                                                            <i className="mdi mdi-clock-outline" />
                                                        </span>
                                                    </div>
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="4">
                                            <div className="mb-3">
                                                <Label>
                                                    Birth country <span style={{ color: 'red' }}>*</span>
                                                </Label>
                                                <AvField type="select" name="birthCountry" onChange={(event) => {
                                                    let country = JSON.parse(event.target.value);
                                                    this.setState({
                                                        birthCountry: country.code,
                                                    })
                                                }}
                                                >
                                                    {countries.map((country, index) => (
                                                        <option value={JSON.stringify(country)} key={index}>{country.name}</option>
                                                    ))}
                                                </AvField>
                                            </div>
                                        </Col>
                                        <Col lg="4">
                                            <AvGroup className="mb-3">
                                                <Label htmlFor="basicpill-place-input2">
                                                    Birth Place <span style={{ color: 'red' }}>*</span>
                                                </Label>
                                                <AsyncSelect
                                                    value={this.state.selectedPlace}
                                                    onChange={(selectedPlace) => {
                                                        this.setState({
                                                            selectedPlace: selectedPlace || []
                                                        })
                                                    }}
                                                    placeholder={'Select place of birth'}
                                                    loadOptions={this.loadSelectedPlace}
                                                    classNamePrefix="select2-selection"
                                                    // className={this.state.passPlaceErrorField}
                                                    className="my-is-invalid"
                                                />
                                                {this.state.passPlaceErrorElement &&
                                                    <div className="my-invalid-feedback">Please select a birth place</div>
                                                }
                                            </AvGroup>
                                        </Col>
                                        <Col lg="4">
                                        <AvGroup className="mb-3 select2-container">
                                            <Label htmlFor="basicpill-place-input2">
                                                Birth type <span style={{ color: 'red' }}>*</span>
                                            </Label>
                                            <AvField type="select"
                                            name="birthType"
                                            //label="Birth type"
                                            // helpMessage="Idk, this is an example. Deal with it!"
                                            required
                                            errorMessage="Please select a birth type"
                                            >
                                            <option disabled value="">Select birth type</option>
                                            <option>Natural </option>
                                            <option>Caesarean  </option>
                                            <option>Vacuum Extraction</option>
                                            <option>Forceps Delivery</option>
                                            </AvField>
                                        </AvGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                    <Col lg="4">
                                    <Label htmlFor="basicpill-place-input2">
                                    Blood Group <span style={{ color: 'red' }}>*</span>
                                    </Label>
                                    <AvGroup className="mb-3 select2-container">
                                        <AvField type="select"
                                        name="bloodGroup"
                                        //label="Blood Group"
                                        // helpMessage="Idk, this is an example. Deal with it!"
                                        required
                                        errorMessage="Please select a blood group"
                                        >
                                        <option disabled value="">Select blood group</option>
                                        <option>A+</option>
                                        <option>A-</option>
                                        <option>B+</option>
                                        <option>B-</option>
                                        <option>AB+</option>
                                        <option>AB-</option>
                                        <option>O+</option>
                                        <option>O-</option>
                                        </AvField>
                                    </AvGroup>
                                        </Col>
                                        <Col lg="4">
                                        <AvGroup className="mb-3 select2-container">
                                            <Label>
                                                IQ Level <span style={{ color: 'red' }}>*</span>
                                            </Label>
                                            <AvField
                                                name="iqLevel"
                                                placeholder="IQ Level"
                                                type="text"
                                                errorMessage="Please enter IQ Level"
                                                className="form-control"
                                                required
                                                helpMessage=""
                                                maxLength="3"
                                                validate={{
                                                    pattern: { value: '^[0-9]{2,3}$', errorMessage: 'Please enter a valid 2 or 3 digit IQ Level' }
                                                }}
                                                />
                                        </AvGroup>
                                        </Col>
                                        <Col lg="4">
                                            <AvGroup className="mb-3">
                                                <Label>
                                                    Reffered by <span style={{ color: 'red' }}>*</span>
                                                </Label>
                                                <AvField
                                                    name="refferedBy"
                                                    placeholder="Reffered by"
                                                    type="text"
                                                    errorMessage="Please enter reffered by"
                                                    className="form-control"
                                                    required
                                                    helpMessage="Reffered by self / Doctor name"
                                                />
                                            </AvGroup>
                                        </Col>
                                    </Row>

                                    <Alert color="info" className="mb-4" role="alert">
                                        <h5 className="font-size-16 me-3">Personal details</h5>
                                    </Alert>

                                    <Row>
                                        <Col lg="6">
                                            <AvGroup className="mb-3">
                                                <Label>
                                                    Aadhar number
                                                </Label>
                                                <AvField
                                                    name="aadharNumber"
                                                    type="text"
                                                    placeholder="Aadhar Number"
                                                    maxLength="12"
                                                    validate={{
                                                        pattern: { value: '^[0-9]{12}$', errorMessage: 'Please enter a valid 12 digit aadhar number' }
                                                    }}
                                                />
                                            </AvGroup>
                                        </Col>
                                        <Col lg="6">
                                            <AvGroup className="mb-3">
                                                <Label>
                                                    Passport number
                                                </Label>
                                                <AvField
                                                    name="passportNumber"
                                                    type="text"
                                                    placeholder="Passport Number"
                                                    maxLength="9"
                                                    validate={{
                                                        pattern: { value: '^[a-zA-Z0-9]{3,9}$', errorMessage: 'Please enter a valid passport number' }
                                                    }}
                                                />
                                            </AvGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <Row>
                                                <Label htmlFor="basicpill-countryCode">
                                                    Address <span style={{ color: 'red' }}>*</span>
                                                </Label>
                                                <Col>
                                                    <div className="mb-3">
                                                        <AvField
                                                            name="address1"
                                                            type="text"
                                                            placeholder="Address"
                                                            validate={{
                                                                required: { value: true, errorMessage: 'Please enter a address' },
                                                                minLength: { value: 10, errorMessage: 'Address must have minimum 10 characters.' },
                                                            }}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div className="mb-3">
                                                        <AvField
                                                            name="address2"
                                                            type="text"
                                                            placeholder="Address"
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>


                                    <Row>
                                        <Col>
                                            <div className="mb-3">
                                                <Label>
                                                    City <span style={{ color: 'red' }}>*</span>
                                                </Label>
                                                <AvField
                                                    name="city"
                                                    type="text"
                                                    placeholder="City"
                                                    validate={{
                                                        required: { value: true, errorMessage: 'Please enter a city' }
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="mb-3">
                                                <Label>
                                                    State <span style={{ color: 'red' }}>*</span>
                                                </Label>
                                                <AvField
                                                    name="state"
                                                    type="text"
                                                    placeholder="State"
                                                    validate={{
                                                        required: { value: true, errorMessage: 'Please enter a state' }
                                                    }}

                                                />
                                            </div>
                                        </Col>

                                        <Col md="4">
                                            <Label>
                                                Zip <span style={{ color: 'red' }}>*</span>
                                            </Label>
                                            <AvField
                                                name="zipCode"
                                                placeholder="Zip Code"
                                                type="text"
                                                errorMessage=" Please provide a valid zip code."
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                id="validationCustom05"
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col className="col-md-4">
                                            <div className="mb-3">
                                                <Label>
                                                    Country <span style={{ color: 'red' }}>*</span>
                                                </Label>
                                                <AvField type="select" name="country" value={JSON.stringify(this.state.country)}  onChange={this.handleCountry}
                                                >
                                                    {countries.map((country, index) => (
                                                        <option value={JSON.stringify(country)} key={index}>{country.name}</option>
                                                    ))}
                                                </AvField>
                                            </div>
                                        </Col>

                                        <Col className="col-md-4">
                                            <Row>
                                                <Label htmlFor="basicpill-countryCode">
                                                    Mobile <span style={{ color: 'red' }}>*</span>
                                                </Label>
                                                <Col md="4" className="pe-md-0 md-pe-3">
                                                    <AvField type="text" name="mobilecode" placeholder="Code" value={this.state.countryCode}
                                                        disabled
                                                        validate={{
                                                            required: { value: true, errorMessage: 'Please select a country code' }
                                                        }}
                                                    >
                                                    </AvField>
                                                </Col>
                                                <Col md="" className="ps-md-0">
                                                    <AvField
                                                        name="mobile"
                                                        type="text"
                                                        placeholder="Mobile"
                                                        validate={{
                                                            required: { value: true, errorMessage: 'Please enter mobile.' },
                                                            pattern: { value: '^[0-9]{8,10}$', errorMessage: 'Please enter a valid mobile.' }
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col className="col-md-4">
                                            <div className="mb-3">
                                                <Label>
                                                    Email <span style={{ color: 'red' }}>*</span>
                                                </Label>
                                                <AvField
                                                    name="email"
                                                    className="form-control"
                                                    placeholder="Email"
                                                    errorMessage="Please enter a vaild email"
                                                    type="email"
                                                    required
                                                />
                                            </div>
                                        </Col>
                                    </Row>

                                    <div className="float-end mt-2">
                                        <button type="submit" className="btn btn-primary w-md">
                                            Submit
                                        </button>
                                    </div>
                                </AvForm>
                            </CardBody>
                        </Card>
                    </Container>
                </div>
            </React.Fragment >
        )
    }
}

BirthDetails.propsTypes = {
    userBirthDetailInput: PropsTypes.func,
    placesAPIToken: PropsTypes.func
}

const mapStateToProps = ({ grpReports, projects }) => ({
    birthDetail: grpReports.birthDetail,
    actionResult: grpReports.actionResult,
    loading: grpReports.loading,
    placesToken: projects.placesToken
})

const mapDispatchToProps = dispatch => ({
    postbirthDetails: (birthDetail, history) => dispatch(postGRPBirthDetails(birthDetail, history)),
    placesAPIToken: () => dispatch(getPlacesAPIToken())
})

export default connect(mapStateToProps, mapDispatchToProps)(BirthDetails)
